/* global AFRAME */

AFRAME.registerComponent('toggle-video', {
  schema: {
    on: {type: 'string'},
    target: {type: 'selector'},
  },

  init: function () {
    var data = this.data;
    var el = this.el;

    el.addEventListener(data.on, () => {
      var video = document.querySelector(data.target.getAttribute('src'));

      if (!video.paused && !video.ispaused) {
        video.pause();
        video.isplaying = false;
        video.ispaused = true;
        document.querySelector("#pause-button").setAttribute('visible', false);
        document.querySelector("#pause-button").setAttribute('material', 'opacity', 0.0);
        document.querySelector("#play-button").setAttribute('visible', true);
        document.querySelector("#play-button").setAttribute('material', 'opacity', 1.0);
      } else if (video.paused && !video.isplaying) {
        var playPromise = video.play();
        if (playPromise) {
          playPromise.then(() => {
            video.isplaying = true;
            video.ispaused = false;
            document.querySelector("#play-button").setAttribute('visible', false);
            document.querySelector("#play-button").setAttribute('material', 'opacity', 0.0);
            document.querySelector("#pause-button").setAttribute('visible', true);
            document.querySelector("#pause-button").setAttribute('material', 'opacity', 1.0);
          }).catch((error) => {
            video.isplaying = false;
            video.ispaused = true;
            document.querySelector("#pause-button").setAttribute('visible', false);
            document.querySelector("#pause-button").setAttribute('material', 'opacity', 0.0);
            document.querySelector("#play-button").setAttribute('visible', true);
            document.querySelector("#play-button").setAttribute('material', 'opacity', 1.0);
            console.log('Error in toggle ' + error);
          });
        }
      }
    });
  },
});




// WEBPACK FOOTER //
// ./js/components/toggle-video.js